<div class="bet-panel__tabs">
    <segment-control class="bet-panel__picker--tabs"
                     [options]="tabs"
                     [selected]="currentTab"
                     [disabled]="disabled ||
                      betButtonState.actionInProgress ||
                       (betButtonState.stateName !== EBetButtonState.NoBet &&
                       betButtonState.stateName !== EBetButtonState.BetNotPrepared)"
                     (select)="onTabChange($event)"></segment-control>
    <button-text class="bet-panel__button--multi-panel" [buttonModifier]="'transparent'"
                 [timeoutMs]="0"
                 [bclass]="'bet-panel__button--multi-panel-inner-bclass'"
                 [disabled]="disabled || multiPanelButtonDisabled ||
                  (betIndex !== 0 && ((betButtonState.stateName !== EBetButtonState.NoBet &&
                       betButtonState.stateName !== EBetButtonState.BetNotPrepared) || betButtonState.actionInProgress))"
                 (onClick)="multiPanelButtonClicked.emit()">
        <span class="bet-panel__icon-wrapper {{betIndex === 0 ? 'plus' : 'minus'}}"></span>
    </button-text>
</div>
<div class="bet-panel__content" *ngIf="betButtonState">
    <ng-container *ngIf="currentTab.value === 'bet'; then betSection; else autoBetSection"></ng-container>
</div>

<ng-template #betSection>
    <div class="bet-panel__container--bet-section not-autoplay">
        <div class="bet-panel__container--main-controls">
            <ng-container [ngTemplateOutlet]="betControls"></ng-container>
        </div>
    </div>
</ng-template>
<ng-template #autoBetSection>
    <div class="bet-panel__container--bet-section">
        <div class="bet-panel__container--main-controls">
            <ng-container [ngTemplateOutlet]="betControls"></ng-container>
        </div>
        <div class="bet-panel__container--autoplay">
            <div class="bet-panel__container--autoplay-button">
                <button-text class="bet-panel__button-auto-play-options"
                             [buttonModifier]="betButtonState.autoplayRoundCount ? 'negative' : 'transparent'"
                             [disabled]="disabled || betButtonState.actionInProgress ||
                              (betButtonState.stateName !== EBetButtonState.NoBet &&
                               betButtonState.stateName !== EBetButtonState.BetNotPrepared && !betButtonState.autoplayRoundCount)"
                             [bclass]="'bet-panel__button-auto-play-options--bclass'"
                             [soundOnClick]="null"
                             (onClick)="betButtonState.autoplayRoundCount ? removeAutoplay.emit() :
                              onAutoPlayOptionsClicked.emit(autoplayOptionsTemplate)">
                    <span class="bet-panel__button-text-auto-play-options">
                        {{(betButtonState.autoplayRoundCount ? ("STOP" | translate) + "(" + betButtonState.autoplayRoundCount + ")" : ("AUTOPLAY" | translate))}}
                    </span>
                </button-text>
            </div>
            <div class="bet-panel__container--auto-cash-out-multiplier">
                <div class="bet-panel__container--auto-cash-out-multiplier-label">
                    <p class="bet-panel__text--name">{{'AUTO_CASH_OUT_SHORT' | translate}}</p>
                    <button-icon [buttonModifier]="'transparent'" tooltip [tooltipTemplate]="hint" #infoButton
                                 class="bet-panel__button--info" [forcePosition]="{directionY: EDirectionY.ToTop,
                  fromElement: { elementRef: $any(infoButton.button), alignX: EXCoordAlignment.Center, alignY: EYCoordAlignment.Top}}"
                                 [tooltipStyles]="hintStyles"
                                 [imageUrl]="'assets/images/ui-elements/ui_autorebuyInfo_icon.png'"></button-icon>
                    <toggle-button class="bet-panel__toggle--auto-cash-out-multiplie"
                                   [value]="autoCashOutMultiplierEnabled"
                                   [disabled]="disabled || betButtonState.actionInProgress || (betButtonState.stateName !== EBetButtonState.NoBet && betButtonState.stateName !== EBetButtonState.BetNotPrepared)"
                                   (stateChanged)="onMultiplierCashOutChange($event)"></toggle-button>
                    <ng-template #hint>
                        <p class="bet-panel__text--hint">{{'AUTO_CASHOUT_MULTIPLIER_HINT' | translate}}</p>
                    </ng-template>
                </div>
                <div class="bet-panel__container--auto-cash-out-multiplier-stepper">
                    <stepper-control class="bet-panel__buttons--auto-cash-out-multiplier-stepper-bet"
                                     [initialValue]="selectedAutoCashoutMultiplier"
                                     [formatWith]="formatStepperNumber"
                                     [maxValue]="autoCashOutMaxValue"
                                     [minValue]="multiplierStepperConfig.minValue"
                                     [disabled]="disabled || !autoCashOutMultiplierEnabled || betButtonState.actionInProgress ||
                                      (betButtonState.stateName !== EBetButtonState.NoBet && betButtonState.stateName !== EBetButtonState.BetNotPrepared)"
                                     (onSelect)="updateMultiplierSelectedValue($event)"></stepper-control>
                </div>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #autoplayOptionsTemplate>
    <autoplay-options [config]="getAutoPlayOptionsConfig()" [balanceAvailable]="balanceAvailable"
                      [currentBetAmount]="selectedBetAmount || betPanelStepperConfig.initialValue"
                      (startAutoplay)="startAutoplay($event)"></autoplay-options>
</ng-template>
<ng-template #betControls>
    <div class="bet-panel__container--bet-controls">
        <stepper-control class="bet-panel__buttons--stepper-bet"
                         [style.display]="betButtonState.stateName !== EBetButtonState.RoundPlaying ? 'flex' : 'none'"
                         [initialValue]="betPanelStepperConfig.initialValue"
                         [formatWith]="formatBalanceStepperNumber"
                         [maxValue]="betPanelStepperConfig.maxValue"
                         [minValue]="betPanelStepperConfig.minValue"
                         [disabled]="disabled || betButtonState.actionInProgress ||
                          (betButtonState.stateName !== EBetButtonState.NoBet && betButtonState.stateName !== EBetButtonState.BetNotPrepared)"
                         (onSelect)="updateSelectedValue($event)"></stepper-control>
        <group-bet-buttons class="bet-panel__buttons--predefined-bet"
                           [currentValue]="selectedBetAmount"
                           [style.display]="betButtonState.stateName !== EBetButtonState.RoundPlaying ? 'flex' : 'none'"
                           [buttonsInARow]="2"
                           [predefinedBetOptions]="betOptions"
                           [betPanelStepperConfig]="betPanelStepperConfig"
                           [deselectEnabled]="true"
                           [disabled]="disabled || betButtonState.actionInProgress ||
                            (betButtonState.stateName !== EBetButtonState.NoBet && betButtonState.stateName !== EBetButtonState.BetNotPrepared)"
                           (select)="updateSelectedValue($event)"></group-bet-buttons>
        <ng-container *ngIf="betButtonState.stateName === EBetButtonState.RoundPlaying">
            <button-text class="bet-panel__button-bet half" [buttonModifier]="EButtonModifier.BUTTON_ACTION"
                         [soundOnClick]="betButtonSoundType" walletAnimation
                         [disabled]="!!firstHalfCashedOut || disabled || betButtonState.actionInProgress"
                         [customLoaderData]="buttonLoaderImage"
                         (onClick)="handleAction(betButtonState.stateName, EBetSplit.FirstHalf)">
                <p class="bet-panel__button-text-bet" *ngIf="!firstHalfCashedOut"
                   [class.pulse-animation]="betButtonState.showAmountInText && betButtonState.accumulatedAmount"
                   [class.pulse-jump-animation]="betButtonState.multiplier && betButtonState.multiplier % 1 >= 0 && betButtonState.multiplier % 1 <= 0.1">
                    <span>{{'CASH_OUT_HALF' | translate}}</span>
                    <span class="bet-panel__text--accumulated-amount"
                          *ngIf="betButtonState.showAmountInText && betButtonState.accumulatedAmount">
                                {{(betButtonState.accumulatedAmount / 2) | balance:true:true}}
                            </span>
                </p>
                <p class="bet-panel__button-text-bet" *ngIf="!!firstHalfCashedOut">
                    <span>{{'CASHED_OUT_HALF' | translate}}</span>
                    <span class="bet-panel__text--accumulated-amount">
                                {{firstHalfCashedOut | balance:true:true}}
                            </span>
                </p>
            </button-text>
        </ng-container>
    </div>
    <div class="bet-panel__container--bet-button">
        <p class="bet-panel__text--waiting-for-round"
           *ngIf="betButtonState.stateName === EBetButtonState.BetPrepared">{{'WAITING_FOR_ROUND' | translate}}</p>
        <button-text class="bet-panel__button-bet" [buttonModifier]="betButtonState.buttonModifier"
                     [soundOnClick]="betButtonSoundType" walletAnimation
                     [disabled]="disabled || betButtonState.actionInProgress"
                     [customLoaderData]="buttonLoaderImage"
                     (onClick)="handleAction(betButtonState.stateName)">
            <p class="bet-panel__button-text-bet"
               [class.pulse-animation]="betButtonState.showAmountInText && betButtonState.accumulatedAmount"
               [class.pulse-jump-animation]="betButtonState.multiplier && betButtonState.multiplier % 1 >= 0 && betButtonState.multiplier % 1 <= 0.1">
                <span class="bet-panel__text--bet-btn-text">{{(betButtonState.textKey) | translate}}</span>
                <span class="bet-panel__text--accumulated-amount"
                      *ngIf="betButtonState.showAmountInText && betButtonState.accumulatedAmount">
                                {{betButtonState.accumulatedAmount | balance:true:true}}
                            </span>
            </p>
        </button-text>
    </div>
</ng-template>
